import React from 'react';
import {Grid, Divider, Icon} from 'semantic-ui-react';
import _ from 'lodash';

import {ANNUAL_SALARY, ANNUAL_BENEFITS} from 'common/requestDetails/constants.js';
import {GRANT_ROSTER_FIELDS} from 'app-ui-componentlibrary/dist/common/constants';
import {ISOToDisplayDate} from 'common/utils';
import {showDollarAmountWithDollar} from 'common/utils';

const {ROSTER_ID} = GRANT_ROSTER_FIELDS;

const dateConfig = {
  showHours: false,
  showDate: true,
};

class EmployeeSlot extends React.Component {
  handleEdit = (e) => {
    const {employee} = this.props;
    e.preventDefault();
    this.props.editEmployee(_.get(employee, ROSTER_ID, 0));
  };

  render() {
    const {employee, divided, isActive, editable} = this.props;
    const {name, startDate, endDate} = employee;
    const startDateDisplay = ISOToDisplayDate(startDate, dateConfig);
    const endDateDisplay = endDate ? ISOToDisplayDate(endDate, dateConfig) : 'Current';
    const annualSalary = _.get(employee, ANNUAL_SALARY);
    const annualBenefits = _.get(employee, ANNUAL_BENEFITS);
    const active = (
      <React.Fragment>
        <Icon name="user" color="green" aria-hidden="true" />
        <strong>Active employee</strong>
      </React.Fragment>
    );
    const inActive = (
      <React.Fragment>
        <Icon name="user" className="user-slash" aria-hidden="true" />
        <strong>Inactive employee</strong>
      </React.Fragment>
    );
    return (
      <React.Fragment>
        {divided && <Divider />}
        <Grid>
          <Grid.Row>
            <Grid.Column width={4}>
              {name} (
              <a href="#" onClick={this.handleEdit}>
                {editable ? 'Edit' : 'View'}
              </a>
              )
            </Grid.Column>
            <Grid.Column width={6}>
              Employment dates: {startDateDisplay} - {endDateDisplay}
            </Grid.Column>
            <Grid.Column width={6}>{isActive ? active : inActive}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <strong>Annual salary</strong> {showDollarAmountWithDollar(annualSalary)}
            </Grid.Column>
            <Grid.Column width={4}>
              <strong>Annual Benefits</strong>{' '}
              {showDollarAmountWithDollar(annualBenefits)}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }
}

export default EmployeeSlot;
